module.exports = __webpack_public_path__ + "static/2-286507962628342e00115e5ec766c19d.jpg";